import React from "react";
import { TPropsWithChildren } from "../types/util";

type TProps = TPropsWithChildren & {
  onClick?: (e?: any) => void;
  className?: string;
  disabled?: boolean;
};
export const IconBtn = (props: TProps) => {
  return (
    <button
      onClick={props.onClick}
      className={`w-[24px] h-[24px] flex justify-center items-center rounded-full ${
        props.disabled ? "" : " hover:bg-gray-200"
      } transition-colors duration-75 ${props.className}`}
      disabled={props.disabled}
    >
      {props.children}
    </button>
  );
};

export default IconBtn;
